<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.addAddress')" />
      <section>
        <v-card :width="$vuetify.breakpoint.smAndUp ? '50%' : '90%'" class="mx-auto">
          <v-card-text>
            <v-form v-model="isValid" @submit.prevent="submitForm" ref="addressForm">
              <v-text-field v-model="form.address_name" :label="$t('label.addressName')" :rules="$rules.requiredRules" :hint="$t('hint.addressName')" persistent-hint />
              <v-text-field v-model="form.receiver_name" :label="$t('label.receiverName')" :rules="$rules.requiredRules" />
              <v-text-field v-model="form.contact_no" :label="$t('label.contactNo')" :rules="$rules.requiredRules" :hint="$t('hint.contactNo')" persistent-hint />
              <v-text-field v-model="form.floor_unit_number" :label="$t('label.floorOrUnitNumber')" :rules="$rules.requiredRules" :hint="$t('hint.floorOrUnitNumber')" persistent-hint />
              <v-text-field v-model="form.address" :label="$t('label.address')" :rules="$rules.requiredRules" />
              <v-text-field v-model="form.postcode" :label="$t('label.postcode')" :rules="$rules.requiredRules" :hint="$t('hint.postcode')" persistent-hint />
              <v-switch v-model="form.default_delivery_address" :label="$t('label.makeDefaultShippingAddress')" inset true-value="1" false-value="0"></v-switch>
              <v-switch v-model="form.default_billing_address" :label="$t('label.makeDefaultBillingAddress')" inset true-value="1" false-value="0"></v-switch>
            </v-form>
          </v-card-text>
        </v-card>
      </section>
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex align-center justify-center">
        <app-button width="12rem" :label="$t('label.addAddress')" :disabled="!isValid" @click="submitForm" />
      </v-container>
    </bottom-bar>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { localeHelper } from '@/utils'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'

export default {
  components: { LayoutContent, SectionTitle },

  props: ['address'],

  data: () => ({
    isValid: false,
    form: {
      address_name: '',
      receiver_name: '',
      country_id: '',
      contact_no: '',
      floor_unit_number: '',
      address: '',
      postcode: '',
      default_delivery_address: 0,
      default_billing_address: 0
    }
  }),
  mounted() {
    this.form.country_id = this.currentUser.country_id
  },
  computed: { ...mapState('auth', ['currentUser']) },
  methods: {
    ...mapActions('auth', ['addAddress']),
    async submitForm() {
      this.form.contact_no = this.form.contact_no
      await this.addAddress(this.form)
        .then(() => {
          this.$toast.success(this.$t('message.addAddressSuccessfully'))
          if (this.$route.path == '/order/add-address') {
            this.$router.push({ name: this.$constants.ROUTE_NAME.ORDER_ADDRESS_BOOK })
          } else {
            this.$router.push({ name: this.$constants.ROUTE_NAME.PROFILE_ADDRESS_BOOK })
          }
        })
        .catch(() => {
          this.$toast.error(this.$t('message.addAddressFailed'))
        })
    }
  }
}
</script>

<style lang="scss" scoped>
// ::v-deep .v-input {
//   .v-input__slot::before {
//     border-style: none;
//   }

//   .v-label {
//     font-weight: bold;
//     color: var(--v-secondary-lighten2);
//   }
// }
</style>
